import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { CheckCircle, PaperPlaneTilt } from "@phosphor-icons/react";

const FIELDS = [
  { key: "name", label: "Name *", required: true },
  { key: "company", label: "Company" },
  { key: "email", label: "Email *", type: "email", required: true },
  { key: "phone", label: "Phone" },
  { key: "zip", label: "Zip code" },
];

export function QuoteRequestForm({ item }) {
  const { user } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "", company: user?.company || "", email: user?.email || "",
    phone: user?.phone || "", zip: "", message: "",
  });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/shop/quotes", { ...form, product_id: item.id });
      setSent(true);
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };

  if (sent) {
    return (
      <div className="border-t border-[#262626] pt-4 mt-4 text-center" data-testid="quote-request-success">
        <CheckCircle size={40} weight="fill" className="text-[#00D4FF] mx-auto mb-2" />
        <div className="font-chivo font-bold text-white uppercase">Quote request sent</div>
        <p className="font-plex text-sm text-[#9CA3AF] mt-1">Check your inbox for a confirmation. We'll reply within one business day.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="border-t border-[#262626] pt-4 mt-4 grid grid-cols-2 gap-2" data-testid="quote-request-form">
      <div className="col-span-2 font-mono text-[10px] text-[#00D4FF] tracking-widest uppercase">Request a quote</div>
      {FIELDS.map((f) => (
        <input key={f.key} type={f.type || "text"} required={f.required} placeholder={f.label} value={form[f.key]}
          onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
          className={`input-rugged ${f.key === "email" ? "col-span-2" : ""}`} data-testid={`quote-field-${f.key}`} />
      ))}
      <textarea rows={3} placeholder="Tell us about your application, compressor, timeline..." value={form.message}
        onChange={(e) => setForm({ ...form, message: e.target.value })} className="input-rugged col-span-2 resize-none" data-testid="quote-field-message" />
      <button type="submit" disabled={busy} className="btn-primary col-span-2 justify-center" data-testid="quote-submit-btn">
        <PaperPlaneTilt size={14} weight="bold" /> {busy ? "Sending..." : "Request a Quote"}
      </button>
    </form>
  );
}
